import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { cartFragment } from '@js/api/fragments/cartFragment'

import { Cart } from '@js/api/types/cart/Cart'

interface ApplyCouponToCartResponse {
  data: {
    applyCouponToCart: {
      cart: Cart
    } | null
  }
  errors?: [{ message: string }]
}

export const applyCouponToCartMutation = gql`
  mutation($cartId: String!, $couponCode: String!) {
    applyCouponToCart(
      input: {
        cart_id: $cartId,
        coupon_code: $couponCode
      }
    ) {
      cart {
        ...CartDetails
      }
    }
  }
  ${cartFragment}
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const applyCouponToCart = async (payload: { cartId: string, couponCode: string }): Promise<Cart | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<ApplyCouponToCartResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: applyCouponToCartMutation,
      variables: {
        cartId: payload.cartId,
        couponCode: payload.couponCode,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.applyCouponToCart) {
    return data.data.applyCouponToCart.cart
  }

  return null
}
